import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export const MiniLoader: React.FC<{
  height?: string;
  size?: string;
  styleObj?: any;
  color?: string;
}> = ({ height = '500px', size, styleObj = {}, color }) => (
  <div
    id="loader_wrapper"
    style={{
      display: 'grid',
      placeItems: 'center',
      height: height,
      ...styleObj
    }}
  >
    <CircularProgress id="loader" size={size} style={{ color: color || '#48F9FE' }} />
  </div>
);
